module.exports = __webpack_public_path__ + "static/original-80b08de3e67143292ace0d282bd8ed59.jpg";